import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import provedor from './http/provedor'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.prototype.$http = http

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

new Vue({
  router,
  store: provedor,
  render: h => h(App)
}).$mount('#app')
